// import React, { useRef, useState } from 'react';
// import {
//   Autocomplete, GoogleMap, Marker,
// } from '@react-google-maps/api';

// const containerStyle = {
//   width: '100%',
//   height: '400px',
// };

// const defaultCenter = {
//   lat: 51.505,
//   lng: -0.09,
// };

// const mapOptions = {
//   disableDefaultUI: true,
// };

// export default function MyGoogleMap(): React.ReactElement {
//   const [mapCenter, setMapCenter] = useState(defaultCenter);
//   const [markerPosition, setMarkerPosition] = useState(defaultCenter);
//   const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

//   const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
//     autocompleteRef.current = autocomplete;
//   };

//   const onPlaceChanged = () => {
//     const place = autocompleteRef.current?.getPlace();
//     const location = place?.geometry?.location;

//     if (location) {
//       const newPos = {
//         lat: location.lat(),
//         lng: location.lng(),
//       };

//       setMapCenter(newPos);
//       setMarkerPosition(newPos);
//     }
//   };

//   return (
//       <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
//         <input
//           type="text"
//           placeholder="Search for a place"
//           style={{
//             width: '300px',
//             height: '40px',
//             padding: '0 12px',
//             position: 'absolute',
//             top: '10px',
//             left: '10px',
//             zIndex: 1000,
//           }}
//         />
//       </Autocomplete>

//       <GoogleMap
//         mapContainerStyle={containerStyle}
//         center={mapCenter}
//         zoom={14}
//         options={mapOptions}
//       >
//         <Marker position={markerPosition} />
//       </GoogleMap>
//   );
// }

import React from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { useGoogleMapsContext } from '../../../GoogleMapsProvider';
import Loading from '../Loading';
import { LatLng } from '../../../types/google';

const containerStyle = {
  width: '100%',
  height: '400px',
};

const mapOptions = {
  disableDefaultUI: true,
};

interface MyGoogleMapProps {
  center: LatLng;
  marker: LatLng;
  // We keep 'any' here or define a specific shape to avoid crashing on imports
  // You can cast it later: (e: google.maps.MapMouseEvent)
  // onMapClick: (e: any) => void;
  onMapClick: (e: google.maps.MapMouseEvent) => void;
}

export default function MyGoogleMap({
  center,
  marker,
  onMapClick,
}: MyGoogleMapProps): React.ReactElement {
  const { isLoaded, loadError } = useGoogleMapsContext();

  if (loadError) return <div>Error loading maps</div>;

  // Only this specific box waits for the script
  if (!isLoaded) return <Loading absolute />;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
      options={mapOptions}
      onClick={onMapClick}
    >
      <Marker position={marker} />
    </GoogleMap>
  );
}
